// Module
var code = "<svg viewBox=\"0 0 20 20\" fill=currentColor> <path fill-rule=evenodd d=\"M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z\" clip-rule=evenodd /> </svg> ";
// Exports
module.exports = code;